import { render, staticRenderFns } from "./terms-updated-manager.vue?vue&type=template&id=46e3a675&scoped=true&"
import script from "./terms-updated-manager.ts?vue&type=script&lang=ts&"
export * from "./terms-updated-manager.ts?vue&type=script&lang=ts&"
import style0 from "./terms-updated-manager.scss?vue&type=style&index=0&id=46e3a675&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e3a675",
  null
  
)

component.options.__file = "terms-updated-manager.vue"
export default component.exports